import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';

const timeline = [
  { year: '2019', title: '平台起步', desc: '秘密教学正式上线，首批上线语言与 IT 类课程，服务第一批种子学员。' },
  { year: '2021', title: '品类扩张', desc: '新增财经管理、职业技能与设计创意领域，课程体系初具规模。' },
  { year: '2023', title: '教研升级', desc: '组建专职教研团队，建立课程质量评估体系，认证讲师突破百位。' },
  { year: '2026', title: '全面开放', desc: '推出专题式学习与智能推荐，累计学员超过 86 万，持续陪伴每一次成长。' },
];

const team = [
  { name: '林知远', role: '创始人 · CEO', desc: '十年教育行业经验，坚信优质内容是学习的核心。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20education%20company%20founder%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20confident%20warm%20expression%2C%20high%20detail%20editorial%20photography&width=300&height=300&seq=team-ceo&orientation=squarish' },
  { name: '沈书宁', role: '教研总监', desc: '主导课程体系搭建，把关每一门课程的教学质量。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20academic%20director%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20calm%20intelligent%20expression%2C%20high%20detail%20editorial%20photography&width=300&height=300&seq=team-research&orientation=squarish' },
  { name: '赵启帆', role: '技术负责人', desc: '带领团队打磨流畅稳定的学习体验与产品功能。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20tech%20lead%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20focused%20friendly%20expression%2C%20high%20detail%20editorial%20photography&width=300&height=300&seq=team-tech&orientation=squarish' },
  { name: '许清和', role: '学员运营', desc: '关注每一位学员的学习路径，让学习更有陪伴感。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20community%20operations%20manager%20portrait%2C%20soft%20studio%20lighting%2C%20plain%20light%20gray%20background%2C%20clean%20minimal%20business%20headshot%2C%20warm%20approachable%20expression%2C%20high%20detail%20editorial%20photography&width=300&height=300&seq=team-ops&orientation=squarish' },
];

const advantages = [
  { icon: 'ri-stack-line', title: '体系化课程体系', desc: '六大领域、上百门课程，从入门到进阶路线清晰，告别碎片化学习。' },
  { icon: 'ri-shield-star-line', title: '严选认证讲师', desc: '讲师均经过教学能力与行业经验双重审核，内容专业可信。' },
  { icon: 'ri-device-line', title: '多端灵活学习', desc: '电脑与手机随时学习，进度自动记录，利用碎片时间持续进步。' },
  { icon: 'ri-customer-service-2-line', title: '贴心学习服务', desc: '专属学习顾问与社群陪伴，遇到问题随时获得解答与鼓励。' },
];

const services = [
  '在线课程学习与视频演示',
  '课程分类检索与个性化筛选',
  '专题式系统学习路线推荐',
  '课程收藏与学习进度管理',
];

export default function About() {
  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-8 pt-10 md:pt-14">
        <div className="rounded-lg border border-background-200 bg-primary-950 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-6 md:p-10 lg:p-12">
              <span className="inline-block text-xs md:text-sm font-medium text-secondary-300 mb-3 tracking-wide">
                关于秘密教学
              </span>
              <h1 className="font-heading font-extrabold text-2xl md:text-4xl text-background-50 leading-tight mb-4">
                专业的教育资源与课程培训平台
              </h1>
              <p className="text-sm md:text-base text-primary-100/85 leading-relaxed mb-6">
                秘密教学致力于提供丰富的教育资源和优质的课程培训，涵盖语言、IT 技术、财经管理等多领域教学内容，
                帮助用户提升学习效果和技能水平。我们相信，每个人都值得拥有高质量、可信赖的学习资源。
              </p>
              <Link
                to="/category"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始探索课程
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
            </div>
            <div className="relative min-h-[240px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20educational%20workspace%20with%20laptop%20books%20and%20soft%20natural%20light%20on%20a%20clean%20light%20gray%20desk%2C%20calm%20professional%20atmosphere%2C%20abstract%20stylized%20composition%2C%20deep%20blue%20and%20teal%20accents%2C%20high%20detail%20editorial%20photography&width=1200&height=900&seq=about-hero-01&orientation=landscape"
                alt="秘密教学学习场景"
                title="秘密教学 · 专业教育平台"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-primary-950/20"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="成长轨迹"
          title="我们的发展历程"
          desc="从第一门课到今天的课程体系，每一步都围绕更好的学习体验。"
        />
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {timeline.map((item, i) => (
              <div key={item.year} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-heading font-bold text-sm">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="font-heading font-extrabold text-xl text-primary-600">{item.year}</span>
                </div>
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 border-y border-background-200">
        <div className="px-4 md:px-8 py-10 md:py-14">
          <SectionHeading
            eyebrow="平台优势"
            title="为什么选择秘密教学"
            desc="我们用体系、师资与服务，让每一次学习都更高效、更安心。"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {advantages.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 text-2xl mb-4">
                  <i className={item.icon}></i>
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="核心团队"
          title="一群认真做教育的人"
          desc="教研、技术与运营团队协同，只为呈现更好的学习内容与体验。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {team.map((member) => (
            <div key={member.name} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="w-full aspect-square overflow-hidden bg-background-200">
                <img
                  src={member.avatar}
                  alt={member.name}
                  title={`${member.name} · 秘密教学团队`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-base text-foreground-950">{member.name}</h3>
                <div className="text-xs text-secondary-600 font-medium mb-2">{member.role}</div>
                <p className="text-sm text-foreground-600 leading-relaxed">{member.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-10 md:pb-14">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950 mb-3">
              我们提供的服务
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              秘密教学围绕「学、练、用」打造完整的学习闭环，帮助你真正把知识转化为能力。
            </p>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s} className="flex items-start gap-2.5 text-sm text-foreground-800">
                  <span className="w-5 h-5 flex items-center justify-center text-secondary-600 text-lg shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill"></i>
                  </span>
                  {s}
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-lg bg-primary-950 p-6 md:p-8 flex flex-col justify-center">
            <h3 className="font-heading font-bold text-xl text-background-50 mb-2">有疑问或想合作？</h3>
            <p className="text-sm text-primary-100/80 leading-relaxed mb-5">
              无论是学习咨询、课程建议还是商务合作，我们都乐意与你聊聊。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap self-start"
            >
              联系我们
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}